module.exports = __webpack_public_path__ + "img/user-green.8511392b.svg";